/**
 * Smooth open/close animation for the native <details>/<summary> FAQ
 * accordions on this page. Progressive enhancement only — without this
 * script the accordions still work perfectly via native browser behaviour
 * (instant open/close), keyboard access and screen readers are untouched.
 * Pattern: WAAPI height tween, keyed off the browser's own synchronous
 * layout (reading offsetHeight right after toggling `open` forces a reflow,
 * so no requestAnimationFrame wait is needed to measure the new height).
 *
 * The end-height for each tween is always measured directly off the
 * <details> element itself (not summed from its children) — summing
 * summary+body offsetHeights misses the element's own border, so the
 * animation would land ~2px short of the browser's natural resting height
 * and visibly snap that last bit the instant it finished.
 */
class FsAccordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector(":scope > summary");
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = "hidden";
    if (this.isClosing || !this.el.open) {
      this.expand();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const wasOpen = this.el.open;
    this.el.open = false;
    const endHeight = `${this.el.offsetHeight}px`;
    this.el.open = wasOpen;
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate(
      { height: [startHeight, endHeight] },
      { duration: 300, easing: "ease-out" }
    );
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  expand() {
    const startHeight = `${this.el.offsetHeight}px`;
    this.el.open = true;
    const endHeight = `${this.el.offsetHeight}px`;
    this.isExpanding = true;
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate(
      { height: [startHeight, endHeight] },
      { duration: 300, easing: "ease-out" }
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = "";
  }
}

document.querySelectorAll(".fs-accordion").forEach((el) => new FsAccordion(el));
